import { pickConstants } from '../_constants';
import { pickService } from '../_services';

export const pickActions = {
    getTodaysPicks
};

function getTodaysPicks(token, sport) {
    return dispatch => {
        dispatch(request());

        pickService.getTodaysPicks(token, sport)
            .then(
                picks => dispatch(success(picks)),
                error => dispatch(failure(error))
            );
    }

    function request() { return { type: pickConstants.GET_PICKS_REQUEST } }
    function success(picks) { return { type: pickConstants.GET_PICKS_SUCCESS, picks } }
    function failure(error) { return { type: pickConstants.GET_PICKS_FAILURE, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/picks.js